import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Field } from 'redux-form';

import BooleanRadio from 'components/Input/BooleanRadio';
import { translate } from 'helpers/Translate';
import { gaEvent, getSource } from 'helpers/Ga';

/**
 * Function to set value to true or false
 * @param  {String}  value - String value set to 'true' or 'false'
 * @return {Boolean} -  Return true or false
 */
export const isTrueSet = (value) => value === 'true';

/**
 * Yes no values.
 * @type {Array}
 */
const YES_NO_VALUES = [
    { value: 'true', label: translate('Oui') },
    { value: 'false', label: translate('Non') },
];

const YesNoOptions = ({ className, name, small, isEstimaUpdate }) => {
    const optionsClasses = classnames('radio-squares yes-no', className);

    const gaEventProps = {
        category: isEstimaUpdate ? 'Barometre Estima' : 'Formulaire Estima',
        action: `estima:${isEstimaUpdate ? 'update' : 'form:project'}:call_back_request:yes`,
        label: `from:${getSource()}`,
    };

    return (
        <div className={optionsClasses}>
            {YES_NO_VALUES.map((e) => (
                <Field
                    key={e.value}
                    component={BooleanRadio}
                    name={name}
                    id={`${e.value}-${name}`}
                    label={e.label}
                    radioValue={e.value}
                    normalize={isTrueSet}
                    small={small}
                    onChange={(value) => (value === 'true' ? gaEvent(gaEventProps) : null)}
                />
            ))}
        </div>
    );
};

YesNoOptions.displayName = 'YesNoOptions';

YesNoOptions.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    small: PropTypes.bool,
};

/**
 * YesNoOptions Functional Component.
 */
export default YesNoOptions;
